import * as React from "react";
import { useState } from "react";
import { Input, InputGroupAddon, InputGroupText, InputGroup } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons' 

const PasswordInput = (props) => {
    const [inputType, setInputType] = useState(false)
    return <React.Fragment>
        <InputGroup>
            <InputGroupAddon addonType="prepend">

            </InputGroupAddon>
            <Input {...props} type={inputType ? 'text' : 'password'} />
            <InputGroupText>
                <FontAwesomeIcon onClick={() => setInputType(!inputType)} icon={inputType ? faEyeSlash : faEye} />
            </InputGroupText>
        </InputGroup>
    </React.Fragment>
}

export default PasswordInput; 